import React from "react";
import './CreateTodoButton.css';
import { FcAddRow } from "react-icons/fc";

function CreateTodoButton(props: any) {
  const onClickButton = () => {
    props.setOpenModal((prevState: any) => !prevState)
  };
  return (
    <button
      className="CreateTodoButton"
      onClick={() => onClickButton()}
    >
      <FcAddRow />
    </button>
  );
}

export { CreateTodoButton };